// @ts-nocheck
/**
 *
 * AcapellasPage
 *
 */
import * as React from 'react';
import {useEffect, useState} from 'react';
import styled from 'styled-components/macro';
import {Container, debounce, FormControl, InputAdornment, OutlinedInput} from "@mui/material";
import {useAcapellasSlice} from "app/pages/AcapellasPage/slice";
import {useVoiceModelsSlice} from "app/pages/VoiceModelsPage/slice";
import {useDispatch, useSelector} from "react-redux";
import {
  selectAcapellas,
  selectIsLoading as selectIsAcapellasLoading,
  selectSelectedAcapella,
  selectSongs
} from "app/pages/AcapellasPage/slice/selectors";
import {
  selectIsLoading as selectIsVoicesLoading,
  selectSelectedPreviewVoice,
  selectVoices
} from "app/pages/VoiceModelsPage/slice/selectors";
import {CustomizeAcapellaStackModal} from "app/components/CustomizeAcapellaStackModal/Loadable";
import {useInterval} from "app/hooks/useInterval";
import {GlobalAudioPlayer} from "app/components/GlobalAudioPlayer";
import {SongPreviewCard} from "app/components/SongPreviewCard/Loadable";
import {RequestASongCard} from "app/components/RequestASongCard";
import {BecomeASingerCard} from "app/components/BecomeASingerCard";
import {getStatusOfAcapellaStack} from "app/components/SongPreviewCard/getStatusOfAcapellaStack";
import {SongPreviewCardSkeleton} from "app/components/SongPreviewCard";
import {SongsFaqsContent} from "app/pages/FaqsPage";
import {VoiceSelectButtonModal} from "app/components/voiceSelectButtonModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from '@fortawesome/pro-solid-svg-icons';
import {SongListItem} from "app/components/SongListItem";
import {ConnectSpotifyButton} from "app/pages/AcapellasPage/connectSpotifyButton";
import toast from "react-hot-toast";
import { Link, useOutletContext } from 'react-router-dom';

interface Props {}

export function AcapellasPage(props: Props) {
  const dispatch = useDispatch();
  const { actions: acapellasActions } = useAcapellasSlice();
  const { actions: voiceActions } = useVoiceModelsSlice();
  const isLoadingAcapellas = useSelector(selectIsAcapellasLoading);
  const isLoadingVoices = useSelector(selectIsVoicesLoading);
  const acapellas = useSelector(selectAcapellas);
  const songs = useSelector(selectSongs);
  const voices = useSelector(selectVoices);
  const previewVoice = useSelector(selectSelectedPreviewVoice);
  const selectedAcapella = useSelector(selectSelectedAcapella);
  const [isPolling, setIsPolling] = useState(false)
  const [query, setQuery] = useState(null)
  const [isWaitingForVoiceToTrain, setIsWaitingForVoiceToTrain] = useState(false)
  // @ts-ignore
  const [userProfile, isLoaded, isSignedIn] = useOutletContext();

  // fetch voice models and acapellas
  useEffect(() => {
    // Bugfix check for .Jobs first bc blended voices dont have that field
    if (previewVoice?.Jobs && previewVoice.Jobs?.status !== 'COMPLETED') {
      setIsWaitingForVoiceToTrain(true)
      return;
    } else {
      setIsWaitingForVoiceToTrain(false)
    }

    if (userProfile && isSignedIn) {
      dispatch(Object.assign(acapellasActions.fetchAcapellas(), { payload: { voice: previewVoice }}));
    }
    dispatch(voiceActions.fetchVoices({isSignedIn: isSignedIn}));
  }, [previewVoice, userProfile, isSignedIn]);

  useInterval(() => {
    // make sure this voice is ready before polling
    if (previewVoice?.Jobs && previewVoice.Jobs?.status !== 'COMPLETED') {
      return
    }

    if (!isLoadingAcapellas && acapellas && previewVoice) {
      for (let acapellaStack of acapellas) {
        // check if any acapella stacks not completed
        let status = getStatusOfAcapellaStack(acapellaStack)
        if (status !== 'COMPLETED' && status !== 'EMPTY') {

          setIsPolling(true)
          dispatch(Object.assign(acapellasActions.fetchAcapellas(), { payload: { voice: previewVoice, isPolling: true }}));
          return;
        }
      }
      // if all completed and still polling, stop
      if (isPolling) {
        setIsPolling(false)
      }
    }
  }, 10000)

  const handleClickCustomize = (a) => {
    // TEMP hack to fix broken model if no voice selected, force voice selection
    if (!previewVoice) {
      toast('Select A Voice to Preview Songs')
    } else {
      dispatch(acapellasActions.setSelectedAcapella(a))
    }
  }

  const handleClose = () => {
    dispatch(acapellasActions.setSelectedAcapella(null))
  }

  const handleSelectPreviewVoice = (v) => {
    dispatch(voiceActions.setSelectedPreviewVoice(v))
  }

  const handleSearchSongs = (newQuery) => {
    dispatch(acapellasActions.searchSongs({ query: newQuery }));
  }
  const debouncedHandleSearch = debounce(handleSearchSongs, 500);


  // @ts-ignore
  return (
    <Page>
      <Container maxWidth="lg">
        {/*<h2> Experience songs in your voice </h2>*/}
        {/*<h3> Create ethically sourced AI covers licensed for streaming services</h3>*/}
        {/* @ts-ignore */}
        <Header>
          <h2> Enjoy early access to our catalog </h2>
          <h3> Create and license release-ready AI Covers in your voice from human singers </h3>
          <PreviewVoiceContainer isEmpty={!previewVoice}>
            {/*<PreviewVoiceLabel>Preview Songs as</PreviewVoiceLabel>*/}
            <div className="animate-border-container" style={{borderRadius: '10px'}}>
              <VoiceSelectButtonModal
                  buttonStyles={{
                    height: '56px',
                    marginTop: '-5px',
                    borderRadius: '10px',
                    border: '1px solid rgba(245, 225, 255, 0.74)',
                    background: '#1D0D2C'
                  }}
                  loading={isLoadingVoices}
                  onChange={(o) => handleSelectPreviewVoice(o)}
                  value={previewVoice}
                  optionLabel={(voice) => voice.name}
                  optionValue={(voice) => voice.id}
                  small={true}
              />
              {!previewVoice && (
                  <div className="animate-border-trail" style={{borderRadius: '10px'}}></div>
              )}
            </div>
          </PreviewVoiceContainer>
          {/*<SearchContainer>*/}
          {/*  <FormControl sx={{m: 1, width: '100%', minWidth: '10ch', flexGrow: 1}} variant="outlined">*/}
          {/*    <OutlinedInput*/}
          {/*        id="outlined-adornment-search"*/}
          {/*        type={'text'}*/}
          {/*        value={query}*/}
          {/*        startAdornment={*/}
          {/*          <InputAdornment position="start">*/}
          {/*            <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>*/}
          {/*          </InputAdornment>*/}
          {/*        }*/}
          {/*        placeholder="Search songs, artists, albums..."*/}
          {/*        onChange={handleChangeSearch}*/}
          {/*    />*/}
          {/*  </FormControl>*/}
          {/*</SearchContainer>*/}
          {/*<ConnectSpotifyButton/>*/}
        </Header>
        {!isLoadingVoices && voices && voices.length == 0 && (
            <NoVoiceText>
              You don't have any voices, <Link to="/app/train">Create A Voice</Link> to preview these songs as if you sang them
            </NoVoiceText>
        )}
        {isWaitingForVoiceToTrain && (
            <PleaseWaitText error={true}>
              This voice is not ready yet. Come back to preview these songs in your voice once you get an email that
              this voice is ready.
            </PleaseWaitText>
        )}
        {songs && songs.length > 0 && songs.map(song => (
            <SongListItem song={song} previewVoice={previewVoice} onCustomize={handleClickCustomize}/>
        ))}
        {isPolling && (
            <PleaseWaitText>
              Generating previews in your voice... This may take a few minutes
            </PleaseWaitText>
        )}
        <SongPreviewList>
          {!isLoadingAcapellas && acapellas && acapellas.map((acapellaStack, index) => (
              <SongPreviewCard uniqueKey={'card' + index} acapellaStack={acapellaStack}
                               onCustomize={handleClickCustomize} size={'default'} previewVoice={previewVoice}/>
          ))}
          {isLoadingAcapellas && [1, 2, 3, 4].map(() => (
              <SongPreviewCardSkeleton/>
          ))}
        </SongPreviewList>
        <br/>
        <h2> Over 20,000+ covers coming soon </h2>
        <FooterActionCards>
          <BecomeASingerCard/>
        </FooterActionCards>
        <br/>
        <h2> FAQs </h2>
        <SongsFaqsContent/>
        <br/>
        <br/>
        <br/>
        <GlobalAudioPlayer/>
      </Container>
      {selectedAcapella && (
          <CustomizeAcapellaStackModal open={selectedAcapella} onClose={handleClose} title={"Customize"}
                                       acapellaStack={selectedAcapella}/>
      )}
    </Page>
  );
}

const Page = styled.div`
  width: 100vw;
  height: calc(100dvh);
  overflow-y: scroll;
  background: #000000;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  
  margin-bottom: 40px;
  margin-top: 40px;
`

const PreviewVoiceContainer = styled.div<{ isEmpty?: boolean; }>`
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.isEmpty ? "center" : "flex-start"};
  align-items: center;
  margin-right: 20px;
  margin-top: 20px;
  
  max-width: 380px;
  z-index: 1;
`;


const SongPreviewList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const FooterActionCards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  
  @media only screen and (max-width: 600px) {
    flex-wrap: wrap;
  }
`;

const NoVoiceText = styled.div`
  color: #ff74e9;

  text-align: center;
  font-family: Raleway;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  margin-bottom: 20px;
  margin-right: 20px;
  margin-left: 20px;

  a {
    color: #ff74e9;
  }
`;
const PleaseWaitText = styled.div<{ error?: boolean; }>`
  color: ${props => props.error ? "#ff4d4d" : "#55cdc4"};

  text-align: center;
  font-family: Raleway;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  margin-bottom: 20px;
  margin-right: 20px;
  margin-left: 20px;

`;